import toast from 'react-hot-toast';
import { handleHttpError } from '../utils/handleHttpError';

/**
 * setupInterceptors
 * @param {import('axios').AxiosInstance} axiosInstance 
 */
export function setupInterceptors(axiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const payload = handleHttpError(error);
      error.errorPayload = payload;

      // null means request was canceled / aborted — don't show a toast
      if (payload) {
        // Dedupe by httpStatus so repeated failures don't stack toasts
        toast.error(payload.message, {
          id: `http-error-${payload.httpStatus ?? "unknown"}`,
          duration: 5000,
        });
      }

      return Promise.reject(error);
    }
  );
}
